import React from 'react';

import type { SimpleObject } from '@clearverify/types';

import type { GetInviteResponse } from 'src/api';
import { PrepareFormDataType } from 'src/components/auth/SignupByInvitePageForm/utils';

export type FormStepperState = {
  previousStepId?: string | null;
  currentStepId: string;
  nextStepId?: string | null;
  isNextStepAvailable: boolean;
  isLastStep: boolean;
};

export type AuthSignupContextValue = {
  formData: SimpleObject;
  setFormData: (formValues: SimpleObject) => void;
  updateFormData: (formValues: SimpleObject) => void;
  prepareFormData: PrepareFormDataType;

  formStepperState: FormStepperState;
  goToNextStep: () => void;
  goToPreviousStep: () => void;

  inviteData: GetInviteResponse | undefined;
};

export const AuthSignupContext = React.createContext({} as AuthSignupContextValue);
